/* Model */
class TaskReasonModel extends App.Models.BaseModel {
    modelUrl = 'TaskReason';
  }
  
  App.Models.TaskReason = TaskReasonModel;
  
  /* Collection */
  class TaskReasonCollection extends App.Collections.BaseCollection {
    url = 'TaskReason';
    model = App.Models.TaskReason;
  }
  
  App.Collections.TaskReasons = TaskReasonCollection;
  
  /* Router */
  class TaskReasonRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TaskReason';
        const model = App.Models.TaskReason;
        const collectionClass = App.Collections.TaskReasons;
  
        super(entityName, model, collectionClass);
    }
  }
  
  App.Routers.TaskReason = TaskReasonRouter;